import { IntegrationType, NonSensitiveFlightRecordConnectedAccount } from "@nova/schemas"
import { ConnectedAccountDeleteModal } from "./ConnectedAccountDeleteModal"
import { ConfirmationModalProps } from "features/modals/WorkspaceConfirmationModalV2"

export const ConnectedAccountDeleteDjiModal = ({
    account,
    onDelete,
    ...rest
}: {
    account: NonSensitiveFlightRecordConnectedAccount<IntegrationType.dji>
    onDelete: () => Promise<void>
} & ConfirmationModalProps) => {
    return (
        <ConnectedAccountDeleteModal {...rest} cacheKey="dji-connection" handleDelete={onDelete}>
            <h4 className="text-gray-0 mt-4 text-center">
                Disconnecting this account will stop future flight log syncs from{" "}
                {account.accountId}.<br />
                <br />
                Do you want to proceed?
            </h4>
        </ConnectedAccountDeleteModal>
    )
}
